import { render, staticRenderFns } from "./addLive.vue?vue&type=template&id=3bd37a47&scoped=true"
import script from "./addLive.vue?vue&type=script&lang=js"
export * from "./addLive.vue?vue&type=script&lang=js"
import style0 from "./addLive.vue?vue&type=style&index=0&id=3bd37a47&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd37a47",
  null
  
)

export default component.exports